import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { observer } from "mobx-react";
import QrReader from 'react-qr-reader'
import { withStyles } from '@material-ui/core/styles';
import environment from '../environments';
import history from '../authentication/History';

const styles = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing.unit * 3,
    backgroundColor: "black",
  }
});

class Scanner extends Component {
  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];
    this.state = {
      result: 'No result',
      identifier: "",
      modalOpen: false
    }
  }

  handleScan = data => {
    if (data) {
      if (data.startsWith(environment.DELIVERY_HOST)) {
        let urlParts = data.split("/");
        let lastPart = urlParts[urlParts.length - 1]
        let keyPart = lastPart.split("?");
        var key = undefined;
        var identifier = undefined;
        if (keyPart.length > 1) {
          identifier = keyPart[0];
          key = keyPart[keyPart.length - 1].split("=")[1];
        } else {
          identifier = keyPart[0];
        }

        /* Check if already in list */
        var alreadyAssigned = this.props.stickerStore.stickerList.filter(function(sticker) {
          return sticker.identifier === identifier
        })

        if (alreadyAssigned.length > 0) {
          history.push('/stickers/' + alreadyAssigned[0].uuid)
        } else {
          this.setState({modalOpen: true, identifier: identifier, key: key})
        }
      }
    }
  }

  componentDidMount() {
    //console.log(this.props.stickerStore);
  }

  assignSticker() {
    this.props.stickerStore.assignSticker(this.state.identifier, this.state.key);
  }

  handleError = err => {
    console.error(err)
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Dialog
          open={this.state.modalOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Sticker hinzufügen?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Möchten Sie den Sticker zu Ihrer Stickerliste hinzufügen?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button component={Link} to="/stickers" color="primary">
              Nein
            </Button>
            <Button onClick={this.assignSticker.bind(this)} color="secondary" autoFocus>
              Ja
            </Button>
          </DialogActions>
        </Dialog>
        <Grid 
        container
        direction="row"
        justify="center"
        alignItems="center">
          <Grid item xs={12} lg={6}>
            <QrReader
              delay={300}
              onError={this.handleError}
              onScan={this.handleScan}
              style={{ width: '100%', height: '100%' }}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(observer(Scanner));